import { Injectable } from '@angular/core';
import { Fetcher } from '@shared/http/fetcher';
import type { TaxType } from './tax-type';

@Injectable({
    providedIn: 'root',
})
export class TaxTypeFetcher extends Fetcher<TaxType> {
    readonly modelName: string = 'TaxType';

    get resourceName(): string {
        return 'tax-types';
    }
}
